<template>
  <div class="hero" id="top">
    <div class="hero-content justify-content-center row small-height">
      <div class="hero-body col-md-9 col-xs-12 col-xs-offset-0">
        <img class="main-logo" src="@/assets/img/logo-mono.png" alt="Cégjelző Céginformációs Rendszer" />
        <h1>Részletes naprakész céginformációk Messengeren másodpercek alatt</h1>
        <a href="http://m.me/cegjelzo?ref=propromo" class="btn btn-orange col-md-6 col-xs-12" target="_blank">KÉREK MESSENGER ÜZENETET A MEGJELENÉSRŐL</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Hero"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hero-content {
  background: url("../assets/img/hero.jpg") top center;
  background-size: cover;
  margin-top: -5px;
  position: relative;
  display: flex;
}

.full-height {
  min-height: 200px;
  height: 100vh;
}

.small-height {
  height: 550px;
}

h1 {
  color: white;
  font-weight: 700;
  font-size: 42px;
  letter-spacing: 1px;
  margin-bottom: 32px;
}

.small-height .hero-body {
  margin-top: auto;
  margin-bottom: auto;
}

.hero-body {
  text-align: center;
  margin: auto;
}

.hero-body .content {
  width: 100%;
  position: relative;
  z-index: 2;
}

.main-logo {
  margin-bottom: 45px;
}

.scroll-icon {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  width: 100%;
  bottom: 20px;
  z-index: 0;
}

.scroll-icon a {
  margin-left: auto;
  margin-right: auto;
}

.scroll-icon img {
  animation: bounce 3.5s infinite;
  -webkit-animation: bounce 3.5s infinite;
  -moz-animation: bounce 3.5s infinite;
  -o-animation: bounce 3.5s infinite;
}

@media (max-width: 768px) {
  .small-height {
    height: auto;
  }

  h1 {
    font-size: 34px;
    margin-bottom: 32px;
  }

  .hero-content {
    margin-top: 0;
    padding-top: 80px;
    padding-bottom: 80px;
  }

  .main-logo {
    max-width: 200px;
  }
}
</style>
